import { useEffect, useState } from "react";

export function FullscreenButton(): React.JSX.Element {
  const [active, setActive] = useState(Boolean(document.fullscreenElement));
  const [error, setError] = useState("");
  useEffect(() => {
    const changed = (): void => { setActive(Boolean(document.fullscreenElement)); setError(""); };
    document.addEventListener("fullscreenchange", changed);
    return () => document.removeEventListener("fullscreenchange", changed);
  }, []);
  const supported = Boolean(document.fullscreenEnabled && document.documentElement.requestFullscreen);
  const toggle = async (): Promise<void> => {
    setError("");
    try {
      if (document.fullscreenElement) await document.exitFullscreen();
      // Include the body so Radix's portalled menus/dialogs remain visible.
      else await document.documentElement.requestFullscreen();
    } catch { setError("Fullscreen could not be opened. Check your browser permissions."); }
  };
  const label = active ? "Exit fullscreen" : "Fullscreen";
  return <div className="fullscreen-control">
    <button type="button" className="icon-button topbar-icon" aria-label={label} aria-pressed={active}
      title={supported ? label : "Fullscreen is unavailable in this browser"} disabled={!supported} onClick={() => void toggle()}>
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={active ? "M8 3v5H3m13-5v5h5M8 21v-5H3m13 5v-5h5" : "M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5"} />
      </svg>
    </button>
    {error && <span className="header-notice" role="status">{error}<button type="button" onClick={() => setError("")} aria-label="Dismiss fullscreen message">×</button></span>}
  </div>;
}
